export enum GenericAccountStateTypes {
        ARCHIVE = 'archive',
        RESTORE = 'restore',
        DELETE = 'delete'
}